import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styles } from '../../styles/components/searchEndAdornment';

interface SearchEndAdornmentProps {
  searchValue: string;
  handleClear: () => void;
  color?: string;
  size?: number;
  isFetching?: boolean;
}

const SearchEndAdornment = ({ searchValue, handleClear }: SearchEndAdornmentProps) => {
  if (searchValue) {
    return (
      <IconButton sx={styles.iconButton} onClick={handleClear}>
        <CloseIcon />
      </IconButton>
    );
  }
  return null;
};

export default SearchEndAdornment;
